import { MutationTree } from 'vuex';
import { State } from './state';
import { TeilnehmerAntwort } from '@/models/TeilnehmerAntwortModels';
import { BewertungAntwort, UmfrageInfo } from '@/models/UmfrageModels';

export enum MutationTypes {
  //#region ThemenUmfrage
  SetTeilnehmerantworten = 'SETTEILNEHMERANTWORTEN',
  AddTeilnehmerantworten = 'ADDTEILNEHMERANTWORTEN',
  AddTeilnehmerantwortenRange = 'ADDTEILNEHMERANTWORTENRANGE',
  UpdateTeilnehmerantworten = 'UPDATETEILNEHMERANTWORTEN',
  UpdateOrAddTeilnehmerantwortenRange = 'UPDATETEILNEHMERANTWORTENRANGE',
  DeleteTeilnehmerantworten = 'DELETETEILNEHMERANTWORTEN',
  RemoveTeilnehmerantwortenByTeilnehmerguid = 'REMOVETEILNEHMERANTWORTENBYTEILNEHMERGUID',
  //#endregion

  //#region BewertungUmfrage
  SetBewertungantworten = 'SETBEWERTUNGANTWORTEN',
  AddOrUpdateBewertungantwort = 'ADDORUPDATEBEWERTUNGANTWORT',
  AddOrUpdateBewertungantwortRange = 'ADDORUPDATEBEWERTUNGANTWORTRANGE',
  DeleteBewertungantwort = 'DELETEBEWERTUNGANTWORT',
  //#endregion

  //#region BewertungUmfrageInfo
  SetUmfrageInfo = 'SETUMFRAGEINFO',
  //#endregion
}

export type Mutations = {
  //#region ThemenUmfrage
  [MutationTypes.SetTeilnehmerantworten](state: State, teilnehmerantwort: Array<TeilnehmerAntwort>): void;
  [MutationTypes.AddTeilnehmerantworten](state: State, teilnehmerantwort: TeilnehmerAntwort): void;
  [MutationTypes.AddTeilnehmerantwortenRange](state: State, teilnehmerantwort: Array<TeilnehmerAntwort>): void;
  [MutationTypes.UpdateTeilnehmerantworten](state: State, teilnehmerantwort: TeilnehmerAntwort): void;
  [MutationTypes.UpdateOrAddTeilnehmerantwortenRange](state: State, teilnehmerantworten: Array<TeilnehmerAntwort>): void;
  [MutationTypes.DeleteTeilnehmerantworten](state: State, teilnehmerantwortid: number): void;
  [MutationTypes.RemoveTeilnehmerantwortenByTeilnehmerguid](state: State, teilnehmerguid: string): void;
  //#endregion

  //#region BewertungUmfrage
  [MutationTypes.SetBewertungantworten](state: State, bewertungantwort: Array<BewertungAntwort>): void;
  [MutationTypes.AddOrUpdateBewertungantwort](state: State, bewertungantwort: BewertungAntwort): void;
  [MutationTypes.AddOrUpdateBewertungantwortRange](state: State, bewertungantworten: Array<BewertungAntwort>): void;
  [MutationTypes.DeleteBewertungantwort](state: State, bewertungantwortid: number): void;
  //#endregion

  //#region BewertungUmfrageInfo
  [MutationTypes.SetUmfrageInfo](state: State, data: UmfrageInfo | null): void;
};

export const mutations: MutationTree<State> & Mutations = {
  //#region ThemenUmfrage
  [MutationTypes.SetTeilnehmerantworten](state: State, teilnehmerantwort: Array<TeilnehmerAntwort>) {
    state.teilnehmerantworten = teilnehmerantwort;
    sessionStorage.setItem('teilnehmerantworten', JSON.stringify(state.teilnehmerantworten));
  },

  [MutationTypes.AddTeilnehmerantworten](state: State, teilnehmerantwort: TeilnehmerAntwort) {
    state.teilnehmerantworten.push(teilnehmerantwort);
    sessionStorage.setItem('teilnehmerantworten', JSON.stringify(state.teilnehmerantworten));
  },

  [MutationTypes.AddTeilnehmerantwortenRange](state: State, teilnehmerantwort: Array<TeilnehmerAntwort>) {
    state.teilnehmerantworten.push(...teilnehmerantwort);
    sessionStorage.setItem('teilnehmerantworten', JSON.stringify(state.teilnehmerantworten));
  },

  [MutationTypes.UpdateTeilnehmerantworten](state: State, teilnehmerantwort: TeilnehmerAntwort) {
    const oldteilnehmerantwort = state.teilnehmerantworten.find((a) => a.id === teilnehmerantwort.id);
    if (oldteilnehmerantwort != null) {
      const index = state.teilnehmerantworten.indexOf(oldteilnehmerantwort);
      state.teilnehmerantworten.splice(index, 1, teilnehmerantwort);
    } else {
      state.teilnehmerantworten.push(teilnehmerantwort);
    }

    sessionStorage.setItem('teilnehmerantworten', JSON.stringify(state.teilnehmerantworten));
  },

  [MutationTypes.UpdateOrAddTeilnehmerantwortenRange](state: State, teilnehmerantworten: Array<TeilnehmerAntwort>) {
    for (var teilnehmerantwort of teilnehmerantworten) {
      const oldteilnehmerantwort = state.teilnehmerantworten.find((a) => a.id === teilnehmerantwort.id);
      if (oldteilnehmerantwort != null) {
        const index = state.teilnehmerantworten.indexOf(oldteilnehmerantwort);
        state.teilnehmerantworten.splice(index, 1, teilnehmerantwort);
      } else {
        state.teilnehmerantworten.push(teilnehmerantwort);
      }
    }

    sessionStorage.setItem('teilnehmerantworten', JSON.stringify(state.teilnehmerantworten));
  },

  [MutationTypes.DeleteTeilnehmerantworten](state: State, teilnehmerantwortid: number) {
    const oldteilnehmerantwort = state.teilnehmerantworten.find((a) => a.id === teilnehmerantwortid);
    if (oldteilnehmerantwort != null) {
      const index = state.teilnehmerantworten.indexOf(oldteilnehmerantwort);
      state.teilnehmerantworten.splice(index, 1);
    }

    sessionStorage.setItem('teilnehmerantworten', JSON.stringify(state.teilnehmerantworten));
  },

  [MutationTypes.RemoveTeilnehmerantwortenByTeilnehmerguid](state: State, teilnehmerguid: string) {
    state.teilnehmerantworten = state.teilnehmerantworten.filter((ta) => ta.teilnehmerGuid != teilnehmerguid);

    sessionStorage.setItem('teilnehmerantworten', JSON.stringify(state.teilnehmerantworten));
  },
  //#endregion

  //#region BewertungUmfrage
  [MutationTypes.SetBewertungantworten](state: State, bewertungantwort: Array<BewertungAntwort>) {
    state.bewertungantworten = bewertungantwort;
    sessionStorage.setItem('bewertungantworten', JSON.stringify(state.bewertungantworten));
  },

  [MutationTypes.AddOrUpdateBewertungantwort](state: State, bewertungantwort: BewertungAntwort) {
    const oldbewertungantwortIndex = state.bewertungantworten.findIndex((a) => a.id === bewertungantwort.id);
    if (oldbewertungantwortIndex != -1) {
      // const index = state.bewertungantworten.indexOf(oldbewertungantwort)
      state.bewertungantworten.splice(oldbewertungantwortIndex, 1, bewertungantwort);
    } else {
      state.bewertungantworten.push(bewertungantwort);
    }

    sessionStorage.setItem('bewertungantworten', JSON.stringify(state.bewertungantworten));
  },

  [MutationTypes.AddOrUpdateBewertungantwortRange](state: State, bewertungantworten: Array<BewertungAntwort>) {
    for (var bewertungantwort of bewertungantworten) {
      const oldbewertungantwortIndex = state.bewertungantworten.findIndex((a) => a.id === bewertungantwort.id);
      if (oldbewertungantwortIndex != -1) {
        state.bewertungantworten.splice(oldbewertungantwortIndex, 1, bewertungantwort);
      } else {
        state.bewertungantworten.push(bewertungantwort);
      }
    }

    sessionStorage.setItem('bewertungantworten', JSON.stringify(state.bewertungantworten));
  },

  [MutationTypes.DeleteBewertungantwort](state: State, bewertungantwortid: number) {
    const oldbewertungantwort = state.bewertungantworten.find((a) => a.id === bewertungantwortid);
    if (oldbewertungantwort != null) {
      const index = state.bewertungantworten.indexOf(oldbewertungantwort);
      state.bewertungantworten.splice(index, 1);
    }

    sessionStorage.setItem('bewertungantworten', JSON.stringify(state.bewertungantworten));
  },
  //#endregion

  //#region BewertungUmfrageInfo
  [MutationTypes.SetUmfrageInfo](state: State, data: UmfrageInfo | null) {
    state.umfrageInfo = data;
  },
  //#endregion
};
